import HttpService from '../../../services/http/httpService';
import config from '../../../config';
import { ESTADO_TODOS } from '../constants';

// Usuarios del MCP de alumnos (mcp_usuarios_autorizados). El backend exige admin
// de la whitelist + gestor del MCP (MCP_GESTORES) y headquarter 'CEDESCA' en la
// query (verifyHeadquarter) y en el body de las mutaciones (schema .strict()).
// Todo va con silent: true para que la pantalla muestre el mensaje del backend
// (409/422/503) y nunca resuelva un error como exito.
class McpUsuariosService extends HttpService {
  // GET /mcp-usuarios -> { data: UsuarioMcp[], truncado: boolean }
  async listar({ headquarter, search = '', estado = ESTADO_TODOS }) {
    const params = { headquarter };
    if (search) params.search = search;
    if (estado && estado !== ESTADO_TODOS) params.estado = estado;
    return this.get('mcp-usuarios', { params, silent: true });
  }

  // POST /mcp-usuarios -> 201 { usuario }. activo lo pone el servidor (true).
  async crear({ headquarter, email, notas }) {
    return this.post(
      'mcp-usuarios',
      { headquarter, email, ...(notas != null ? { notas } : {}) },
      { params: { headquarter }, silent: true },
    );
  }

  // PATCH /mcp-usuarios/:id con solo los campos cambiados (activo/notas/email).
  async editar({ headquarter, id, cambios }) {
    return this.patch(
      `mcp-usuarios/${id}`,
      { headquarter, ...cambios },
      { params: { headquarter }, silent: true },
    );
  }

  // DELETE /mcp-usuarios/:id -> { ok: true }
  async eliminar({ headquarter, id }) {
    return this.delete(`mcp-usuarios/${id}`, { params: { headquarter }, silent: true });
  }
}

const mcpUsuariosService = new McpUsuariosService(config.REACT_APP_NODE_API);
export default mcpUsuariosService;
